export const offerKeys = {
  offerByPhone: (phone?: string | null) => ['offer-by-phone', phone] as const,
};
